export function ellipsize(text: string): string {
  return text + Characters.Ellipsis
}

export function truncate(text: string, maxLength: number): string {
  return text.length > maxLength
    ? text.substring(0, maxLength - 1) + Characters.Ellipsis
    : text
}


export const Characters = {
  Ellipsis: "\u2026",
  MediumBlackCircle: "\u26AB",
  Nbsp: "\u00A0",
  UpRightArrow: "\u2197",
  Zwsp: "\u200B",
}

export const breakWord = {
  wordBreak: "break-word"
}

export const monospaceFont = {
  fontSize: "var(--monospace-font-size)",
  fontFamily: "var(--monospace-font-family), monospace",
  fontFeatureSettings: "'liga', 'calt'"
}

export const baseFontSize = {
  fontSize: "var(--base-font-size)",
  lineHeight: "var(--base-line-height)"
}

export const smallFontSize = {
  fontSize: "var(--small-font-size)",
  lineHeight: "var(--small-line-height)"
}

export const smallerFontSize = {
  fontSize: "var(--smaller-font-size)",
  lineHeight: "var(--smaller-line-height)"
}

export const smallestFontSize = {
  fontSize: "var(--smallest-font-size)",
  lineHeight: "var(--smallest-line-height)"
}

export const pre = {
  ...monospaceFont,
  ...breakWord,

  margin: "0",
  whiteSpace: "pre-wrap"
}
